import Axios from 'axios';

export const CodigoNotaria = '5';
export const UrlApi = process.env.REACT_APP_UrlApi;

// Genesys Cloud Messenger — UUID → deploymentId (nombre de env puede variar)
export const GenesysEnvironment = 'prod';
export const GenesysDeploymentId ='d9095037-3fa5-4278-875c-2822f4549909';

// Links de redes sociales. Si el proyecto no tiene cuenta propia, se usa el
// home genérico de cada red. Para apuntar a una cuenta real, definir la
// variable de entorno correspondiente (REACT_APP_SOCIAL_*) en el .env.
export const SocialLinks = {
  facebook: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://www.facebook.com/',
  instagram: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://www.instagram.com/',
  x: process.env.REACT_APP_SOCIAL_X || 'https://www.x.com/',
};

const api = Axios.create({
	baseURL: UrlApi,
	headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

export const apiService = {
	getNotaria: () => Axios.get(UrlApi + 'notaria', {
		headers: { Authorization: "Bearer " + process.env.REACT_APP_TOKEN_API }
	}),
	getConfigCotizador: () => Axios.get(UrlApi + 'configCotizador', {
		headers: { Authorization: "Bearer " + process.env.REACT_APP_TOKEN_API }
	}),
	cotizarPublico: (data) => api.post('cotizador/cotizar', data),
};

export default api; 